<template>
  <div v-if="isOpen" class="fixed inset-0 z-50 flex items-center justify-center p-4">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-gray-900/50 backdrop-blur-sm" @click="close"></div>
    
    <!-- Dialog -->
    <div 
      class="relative bg-white rounded-xl shadow-xl overflow-hidden w-full fade-in"
      :class="sizeClass"
    >
      <!-- Header -->
      <div class="flex justify-between items-center px-6 py-4 border-b border-gray-200">
        <h3 class="text-lg font-semibold text-gray-900">{{ title }}</h3>
        <button 
          @click="close" 
          class="w-8 h-8 rounded-lg bg-gray-100 hover:bg-gray-200 flex justify-center items-center transition-colors"
        >
          <font-awesome-icon icon="times" class="text-gray-500" />
        </button>
      </div>
      
      <!-- Content -->
      <div class="p-6 max-h-[70vh] overflow-y-auto">
        <slot></slot>
      </div>
      
      <!-- Footer (optional) -->
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Dialog',
  props: {
    title: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['sm', 'md', 'lg'].includes(value),
    },
  },
  computed: {
    sizeClass() {
      switch (this.size) {
        case 'sm':
          return 'max-w-md'
        case 'lg':
          return 'max-w-3xl'
        default:
          return 'max-w-xl'
      }
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>





